import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappTemplatesCommonLocalesResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappTemplatesCommonLocalesResponseData>>

const commonLocalesQueryKey = () => ["commonLocales"]

export const commonLocalesQuery = (onSuccess: (response: Response["data"]) => void) => {
  return queryOptions({
    queryKey: commonLocalesQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/integrations/whatsapp/templates/common-locales")

      onSuccess(data.data)
      return data.data
    },
    refetchOnWindowFocus: false,
  })
}
